let loading: Promise<void> | null = null

/** Load Google Identity Services once (as sales-tinder's apps/web does). */
export function loadGsi(): Promise<void> {
  loading ??= new Promise((resolve, reject) => {
    const s = document.createElement('script')
    s.src = 'https://accounts.google.com/gsi/client'
    s.async = true
    s.onload = () => resolve()
    s.onerror = () => reject(new Error('Could not load Google sign-in'))
    document.head.appendChild(s)
  })
  return loading
}

declare global {
  interface Window {
    google?: { accounts: { id: {
      initialize(o: { client_id: string; callback: (r: { credential: string }) => void; hd?: string; auto_select?: boolean }): void
      renderButton(el: HTMLElement, o: Record<string, unknown>): void
    } } }
  }
}
